module.exports = __webpack_public_path__ + "static/media/55_000060.d486789d.jpg";